import './index.css';

export default {
  name: 'Biframe',
  props: {
    id: { type: String, default: () => (`b-iframe-${Math.random().toString().substring(2)}`) },
    loading: { type: Boolean, default: () => false },
  },
  mounted() {
    // window.addEventListener('message', (e) => console.log(e));
  },
  methods: {
    create() {
      // this.resize();
    },
    resize() {
      let iframe = document.getElementById(this.id);
      if (iframe && iframe.contentWindow) this.$nextTick(() => {
        let styles = ({
          width: '100%',
          height: '100%',
          margin: '0',
          padding: '0',
          background: 'rgba(0, 0, 0, 0)',
        });
        iframe.contentWindow.postMessage(styles, '*');
      });
    },
  },
  render() {
    const {
      margin = '0',
      padding = '0',
      width = '100%',
      height = '100%',
      scrolling = 'no',
      frameborder = '0',
      seamless = "seamless",
      ...attrs
    } = this.$attrs;
    return (
      <iframe
        id={this.id}
        class="b-iframe"
        seamless={seamless}
        onload={this.create}
        scrolling={scrolling}
        frameborder={frameborder}
        style={{ width, height, margin, padding }}
        {...{ attrs }}
      >
        {this.$slots.default}
      </iframe>
    );
  }
}